<template>
  <div class="divide-y">
    <div class="py-3 px-4" v-if="!hasItems">沒有商品</div>

    <CartListItemCard
      v-for="item in items"
      :key="item.id"
      :item="item"
      :view="view"
      :success="isSuccess"
    />

    <slot name="before-summary"></slot>

    <template v-if="!bill">
      <div v-if="coupon" class="px-4 py-3 text-sm bg-gray-50 border-t border-b">
        <div class="flex flex-col space-y-1.5">
          <!-- 優惠券 -->
          <div class="flex justify-between items-center text-red-500">
            <span>優惠券折扣 ({{ coupon.coupon_code }})</span>
            <span>-{{ currency }} {{ coupon.discount_amount | number_format }}</span>
          </div>
        </div>
      </div>
    </template>

    <div class="border-b py-3 leading-none" v-else>
      <div class="text-right text-sm text-chicago mb-2">
        小計 {{ currency }}{{ amount | number_format }}
      </div>
      <!-- <span v-if="takeaway">運費 {{currency}}{{fee}}<br></span> -->
      <div class="font-bold text-sm text-primary">
        合計 {{ currency }}<span class="text-lg">{{ total | number_format }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CartListItemCard from "@/components/cart/CartListItemCard";

export default {
  components: { CartListItemCard },
  props: {
    view: Boolean,
    amount: [Number, String],
    origin_amount: [Number, String],
    offer: [Number, String],
    count: [Number, String],
    items: Array,
    hasItems: Boolean,
    takeaway: Boolean,
    fee: [Number, String],
    bill: Boolean,
    total: [Number, String],
    status: {
      type: Object,
      default: () => ({}),
    },
    coupon: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isSuccess() {
      return this.status.name == "success";
    },
  },
};
</script>
